import React from 'react';
import '../styles/ContactCTA.css';

const ContactCTA = () => {
  return (
    <div className="contact-cta">
      <div className="cta-content">
        <h2>Get In Touch</h2>
        <p>Have any questions or need more information? We’d love to hear from you. Reach out to us today!</p>
        <button className="cta-button">Contact Us</button>
      </div>
    </div>
  );
}

export default ContactCTA;